import { firestore } from '@psl/functions/firebase/firebaseAccess';

export const userProfileDoc = (id: string) =>
  firestore().collection('profiles').doc(id);
